import React, { useMemo, useState } from 'react';

import { BrandContext } from './themes.hooks';
import { Brand, Union } from './themes.types';

interface BrandContextProviderProps {
  initialBrand: Brand;
}

export const BrandContextProvider = ({
  initialBrand,
  children,
}: React.PropsWithChildren<BrandContextProviderProps>): React.ReactElement => {
  const [brand, setBrand] = useState<Brand>(initialBrand);
  const [union, setUnion] = useState<Union>();

  const value = useMemo(
    () => ({
      brand,
      setBrand,
      union,
      setUnion,
    }),
    [brand, setBrand, union, setUnion],
  );

  return (
    <BrandContext.Provider value={value}>{children}</BrandContext.Provider>
  );
};
